import axiosInstance from './axiosInstance';

const normalizeList = (data, key) => {
  if (Array.isArray(data)) return data;
  if (data && Array.isArray(data[key])) return data[key];
  if (data && Array.isArray(data.data)) return data.data;
  return [];
};

const mapReviewFromApi = (r) => {
  if (!r) return null;
  const customerName =
    r.customer_name ??
    r.customerName ??
    r.customer_email ??
    r.customerEmail ??
    r.customer_phone ??
    r.customerPhone ??
    'Customer';
  return {
    id: r.id,
    customerId: r.customer_id ?? r.customerId,
    customerName,
    orderId: r.order_id ?? r.orderId,
    itemType: r.item_type ?? r.itemType,
    itemId: r.item_id ?? r.itemId,
    productName:
      r.item_name ??
      r.itemName ??
      r.product_name ??
      r.productName ??
      r.combo_name ??
      r.comboName ??
      '',
    rating: Number(r.rating ?? 0),
    comment: r.comment ?? '',
    date: r.created_at ? String(r.created_at).slice(0, 10) : (r.date ?? ''),
    createdAt: r.created_at ?? r.createdAt,
  };
};

export const fetchCustomerReviews = async () => {
  const response = await axiosInstance.get('/customers/reviews');
  const list = normalizeList(response.data, 'reviews') || normalizeList(response.data, 'data') || [];
  return list.map(mapReviewFromApi).filter(Boolean);
};

